export default __webpack_public_path__ + "static/media/profile-picture.79ad0a12.webp";